import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { ProjectTimeBilling } from "@src/components/modules/projects/time-billing";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Time Billing`}
    navigation={<NavigationProjects projectId={id} />}
  >
    <DemoModule module={Modules.TimeBilling}>
      <ProjectTimeBilling id={id} />
    </DemoModule>
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/time-billing")({
  component: RouteComponent,
});
